import { NotebookPen, ShieldCheck, HeartHandshake, Compass } from "lucide-react";

const NOTES = [
  { icon: HeartHandshake, text: "Watch for language that preserves autonomy: offer options, never orders." },
  { icon: ShieldCheck, text: "Address privacy and surveillance before collecting sensitive details." },
  { icon: Compass, text: "Measure success by safety-planning quality, not by how much she discloses." },
];

export const FacilitatorNotes = ({ tally }) => {
  return (
    <aside data-testid="facilitator-notes" className="rounded-2xl border border-stone-200 bg-white p-5 sm:p-6 shadow-sm">
      <div className="flex items-center gap-2 pb-4 border-b border-stone-100">
        <NotebookPen className="h-4 w-4 text-emerald-700" />
        <h2 className="font-heading text-sm font-semibold uppercase tracking-wider text-stone-500">Facilitator Notes</h2>
      </div>
      <ul className="mt-4 space-y-4">
        {NOTES.map((n) => (
          <li key={n.text} className="flex gap-3">
            <n.icon className="h-4 w-4 mt-0.5 shrink-0 text-stone-400" />
            <span className="text-sm leading-relaxed text-stone-600">{n.text}</span>
          </li>
        ))}
      </ul>

      <div className="mt-6 pt-5 border-t border-stone-100">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-stone-400">Choices so far</span>
        <div className="mt-3 space-y-2">
          <TallyRow color="bg-emerald-500" label="Survivor-centered" value={tally.good} />
          <TallyRow color="bg-amber-500" label="Mixed" value={tally.caution} />
          <TallyRow color="bg-rose-500" label="Harmful" value={tally.harmful} />
        </div>
      </div>
    </aside>
  );
};

const TallyRow = ({ color, label, value }) => (
  <div className="flex items-center justify-between text-sm">
    <span className="flex items-center gap-2 text-stone-600">
      <span className={`h-2.5 w-2.5 rounded-full ${color}`} />
      {label}
    </span>
    <span className="font-semibold tabular-nums text-stone-700">{value}</span>
  </div>
);
